import Vue from 'vue';

export default {
  data() {
    return {
      stripe_name: '',
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue')
  },
  async mounted() {
    var vm = this;

    if(vm.$route.query.error && vm.$route.query.error_description) {
      toastr.error(error_description);
    }

    if(vm.$route.query.code && vm.$route.query.scope) {
      var data = {
        'name' : localStorage.getItem('stripe_name'),
        'rental_id' : localStorage.getItem('rental_id'),
        'stripe_account_type' : localStorage.getItem('stripe_account_type'),
        'code' : vm.$route.query.code,
        'scope' : vm.$route.query.scope,
      };
      if (localStorage.getItem('member_id')) {
        data.memberId = localStorage.getItem('member_id');
      }
      //TODO Create Service for Stripe Oauth
      Vue.$http.post('/payments/stripe-oauth', data).then((response) => {
        if (response.status === 200) {
          localStorage.removeItem('stripe_name');
          vm.redirectToPage();
        } else {
          vm.showToasterError(response.data.msg);
        }
      }).catch((error) => {
        if (error.response.data.msg == 'This account already exists') {
          toastr.error(error.response.data.msg);
          if(localStorage.getItem('settings_page') == 'true') {
            localStorage.setItem('account_exists', true);
            vm.redirectToPage();
          }
        } else if(error.response.data.msg == 'Authorization code expired') {
          toastr.error(error.response.data.msg);
          localStorage.setItem('authorization_code_expired', true);
          vm.redirectToPage();
        } else {
          if(error.response.data.msg) {
            toastr.error(error.response.data.msg);
          } else {
            toastr.error(this.$t('something_went_wrong'));
            vm.redirectToPage();
          }
        }
      });
    }
  },
  methods: {
    redirectToPage() {
      if (localStorage.getItem('member_id')) {
        Vue.router.push({
          name: 'update.team.user',
          params: { id: localStorage.getItem('member_id') }
        });
        localStorage.removeItem('member_id');
      } else {
        if(localStorage.getItem('stripe_account_type') === 'account') {
          Vue.router.push({
            name: 'account.settings',
            params: { tab: 'informations' }
          });
        } else if (localStorage.getItem('stripe_account_type') === 'rental') {
          Vue.router.push({
            name: 'rentals.detail',
            params: { id: localStorage.getItem('rental_id') }
          });
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/stripe-process/index/index.js